export default "__VITE_ASSET__fD09rg3L__"